export const accountsCopy = {
  "zh-Hans": {
    "title": "登录 xHalo",
    "description": "使用统一 xHalo 账号登录或注册，完成后自动返回当前应用。",
    "button": "前往主站登录"
  },
  "zh-Hant": {
    "title": "登入 xHalo",
    "description": "使用統一 xHalo 帳號登入或註冊，完成後自動返回目前應用程式。",
    "button": "前往主站登入"
  },
  "en": {
    "title": "Sign in to xHalo",
    "description": "Sign in or register with your xHalo account. You will return to this app when finished.",
    "button": "Continue to main-site sign-in"
  },
  "ja": {
    "title": "xHalo にログイン",
    "description": "共通の xHalo アカウントでログインまたは登録してください。完了後、このアプリに戻ります。",
    "button": "メインサイトでログイン"
  },
  "ko": {
    "title": "xHalo 로그인",
    "description": "통합 xHalo 계정으로 로그인하거나 가입하세요. 완료 후 이 앱으로 돌아옵니다.",
    "button": "메인 사이트에서 로그인"
  }
} as const;
